import React from "react";
import { Divider, Progress, Steps, Switch } from "antd";
import { formatToCurrencyWithScale, roundToDecimals} from "../../helpers/FormatHelper";
import { calculateBuyAmount, getConfirmation, save, sendConfirmation } from "./OrderService";
import { useEffect, useState,useMemo,useRef } from "react";
import { DenominationTypes } from "../../constants/DenominationTypes";
import NumberInput from "../shared/NumberInput";
import LoadingBox from "../shared/LoadingBox";
import AlertBox from "../shared/AlertBox";
import Icon, { BankOutlined, CheckOutlined, DollarOutlined, RocketTwoTone, CheckCircleOutlined, CarryOutFilled }  from '@ant-design/icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTruck } from "@fortawesome/free-solid-svg-icons";
import { AutorenewRounded } from "@material-ui/icons";
import { useCallback } from "react";

export function OrderSummary({objOrder, buyScale, lockedSide, companyAddress, backScreen, cancelOrder, customerID, contactID, customerName, customerAddress, contactName
    , baseCurrencySymbol, updateOrderDenominationFee, updateOrderFees, newOrder, updateOrderRowRate, updateOrderRowCostRate, reload
    , showCostRate, editCostRate, editCustomerRate, getOrderUpdated, saveOrderWithLoss, customerType, fromSearch, view}){
        const { Step } = Steps;
      const [showCompanyAddress, setShowCompanyAddress] = useState(false);
      const [showCompanyAddressWithoutLocation, setShowCompanyAddressWithoutLocation] = useState(false);
      const [showVault, setShowVault] = useState(false);
      const [isDropOff, setIsDropOff] = useState(false);
        const lockedSideLower = lockedSide.toLowerCase();
        const userID=localStorage.getItem('UserID');
        const baseCurrency=localStorage.getItem('BNBase Currency');
        const [orderNo, setOrderNo] = useState(0);
         const allowDenominationType = false;
        const [denominationFee, setDenominationFee] = useState(0);
        const [orderFee, setOrderFee] = useState(0);
        const [deliveryFee, setDeliveryFee] = useState(0);
        const [loading, setLoading] = useState(false);
        const [alertTitle, setAlertTitle] = useState('');
        const [alertMessage, setAlertMessage] = useState('');
        const [comments, setComments] = useState('');
        const [showAlert, setShowAlert] = useState(false);
        const [saved, setSaved] = useState(false);
        const [totalOrder, setTotalOrder] = useState(0);
        const classNameRateRows = showCostRate? "uk-width-1-8":"uk-width-1-8"; 
        const [isPartnerPickUp, setIsPartnerPickUp] = useState(false);
        const [showConfirmation, setShowConfirmation] = useState(false);
        const [showBookConfirmation, setShowBookConfirmation] = useState(false);

        const INITIAL_TIME = localStorage.getItem('BN Transaction Timeout'); 
        
          const [seconds, setSeconds] = useState(INITIAL_TIME);
          const [isRunning, setIsRunning] = useState(false);
        const [showAlertTimer, setShowAlertTimer] = useState(false);
        const intervalRef = useRef(null);
        const isMountedRef = useRef(true);

        useEffect(() => {
            return () => {
                isMountedRef.current = false;

                if (intervalRef.current) {
                    clearInterval(intervalRef.current);
                }
            };
        }, []);


     /* useEffect(() => {
      if (objOrder && objOrder.DeliveryMethod !== '') {
        setShowCompanyAddress((lockedSideLower === 'buy' && objOrder.DeliveryMethod.toLowerCase().includes('sends currency')));
        setShowCompanyAddressWithoutLocation((lockedSideLower === 'sell' && objOrder.DeliveryMethod.toLowerCase().includes('at the vault')));
        setIsPartnerPickUp((lockedSideLower === 'buy' && objOrder.DeliveryMethod.toLowerCase().includes('partner pick')));
        setShowVault(lockedSideLower === 'buy' && objOrder.DeliveryMethod.toLowerCase().includes('armored'));
      }
    }, [objOrder, objOrder.DeliveryMethod, lockedSideLower])*/
    useEffect(() => {

    if (!objOrder?.DeliveryMethod) {
        return;
    }

    const method = objOrder.DeliveryMethod.toLowerCase();

    setShowCompanyAddress(
        lockedSideLower === 'buy' &&
        method.toLowerCase().includes('sends currency')
    );

    setShowCompanyAddressWithoutLocation(
        lockedSideLower === 'sell' &&
        method.toLowerCase().includes('at the vault')
    );

    setIsPartnerPickUp(
        lockedSideLower === 'buy' &&
        method.toLowerCase().includes('partner pick')
    );

    setShowVault(
        lockedSideLower === 'buy' &&
        method.toLowerCase().includes('armored')
    );

    setIsDropOff(
        lockedSideLower === 'buy' &&
        method.includes('drop-off')
    );

}, [objOrder?.DeliveryMethod, lockedSideLower]);

    useEffect(() => {
        if (objOrder?.BNOrderNo > 0) {
            setOrderNo(objOrder.BNOrderNo);
        }
    }, [objOrder?.BNOrderNo]);

    useEffect(() => {
      if (objOrder && objOrder.Comments !== undefined && objOrder.Comments !== null) {
        setComments(objOrder.Comments)
      }
    }, [objOrder, objOrder.Comments])

    useEffect(() => {
      if (objOrder) {
        setTotalOrder(objOrder.TotalOrder);
        setDenominationFee(objOrder.DenominationFee);
        setOrderFee(objOrder.OrderFee);
        setDeliveryFee(objOrder.DeliveryFee);
      }
    }, [objOrder, objOrder.DenominationFee, objOrder.OrderFee, objOrder.DeliveryFee, objOrder.TotalOrder, reload])  


    const onChangeDenominationFeeValue =(value, denominationDescription, rowIndex)=>{        
        const denominations = objOrder.OrderRows[rowIndex].Denominations;
        
        const denominationsAux = JSON.parse(JSON.stringify(denominations))
        const index = denominationsAux.findIndex(d => d.DenominationDescription === denominationDescription);
        if(index > -1)
        {
        denominationsAux[index].DenominationFee = Number(value.toString().replace(",", ""));

        objOrder.OrderRows[rowIndex].Denominations = denominationsAux;

         let fee = 0;
            objOrder.OrderRows.forEach(row =>{
                let rowFee = 0;

                row.Denominations.forEach( d=>
                    rowFee += d.DenominationFee??0
                );

                row.FeeAmount = rowFee;
                fee += rowFee;
            });            
        setDenominationFee(fee);
         if(updateOrderDenominationFee){
            updateOrderDenominationFee(objOrder);
         }
        }
    }

    const onChangeRateValue =(value, index)=>{        
        if(Number(value) > 0)
        {
            const orderRow = objOrder.OrderRows[index];
            
            const orderRowAux = JSON.parse(JSON.stringify(orderRow))

            const inverseRate = orderRowAux.ShowInverseRate;
            const costRateInverseRate = inverseRate? 1/ orderRowAux.CostRate : orderRowAux.CostRate
            const rateInverseRate = inverseRate? 1/Number(value) : Number(value)

            const amountByRate = calculateBuyAmount(orderRowAux.RateTerms, Number(value), lockedSide, orderRowAux.Amount, buyScale, inverseRate);
            const amountByCostRate = calculateBuyAmount(orderRowAux.RateTerms, costRateInverseRate, lockedSide, orderRowAux.Amount, buyScale, inverseRate);
           
            const profit = roundToDecimals(
                lockedSide.toLowerCase() === 'buy' ? 
                (orderRowAux.RateTerms === 'I' ? amountByRate - amountByCostRate : amountByCostRate - amountByRate) :
                (orderRowAux.RateTerms === 'I' ? amountByCostRate - amountByRate : amountByRate - amountByCostRate),
                buyScale
                );
            /*const profit = roundToDecimals(
                      lockedSide.toLowerCase() === 'buy' ? 
                      amountByCostRate - amountByRate :
                      amountByRate - amountByCostRate,
                      buyScale
                    );*/
            
            if(rateInverseRate !== orderRowAux.Rate)
            {
                orderRowAux.AutorefreshRate = false;
            }

            orderRowAux.Rate = rateInverseRate;
            orderRowAux.Profit = profit;
            orderRowAux.BuyAmount = amountByRate;

            const updatedOrder = {
            ...objOrder,
            OrderRows: objOrder.OrderRows.map((row, i) =>
                i === index ? orderRowAux : row
            )
            };

            if(updateOrderRowRate)
            {
            updateOrderRowRate(updatedOrder);
            }
        }
        
    }

     const onChangeCostRateValue =(value, index)=>{     
        if(Number(value)>0)
        {   
            const orderRow = objOrder.OrderRows[index];
            
            const orderRowAux = JSON.parse(JSON.stringify(orderRow))

            const inverseRate = orderRowAux.ShowInverseRate;
            const rateInverseRate = inverseRate? 1/ orderRowAux.Rate : orderRowAux.Rate
            const costRateInverseRate = inverseRate? 1/ Number(value) : Number(value)
            const amountByRate = calculateBuyAmount(orderRowAux.RateTerms, rateInverseRate, lockedSide, orderRowAux.Amount, buyScale, inverseRate);
            const amountByCostRate = calculateBuyAmount(orderRowAux.RateTerms, Number(value), lockedSide, orderRowAux.Amount, buyScale, inverseRate);
          
            const profit = roundToDecimals(
                      lockedSide.toLowerCase() === 'buy' ? 
                      amountByCostRate - amountByRate :
                      amountByRate - amountByCostRate,
                      buyScale
                    );
            
            if(costRateInverseRate !== orderRowAux.CostRate)
            {
                orderRowAux.AutorefreshRate = false;
            }
            orderRowAux.CostRate = costRateInverseRate;
            orderRowAux.Profit = profit;

            const updatedOrder = {
            ...objOrder,
            OrderRows: objOrder.OrderRows.map((row, i) =>
                i === index ? orderRowAux : row
            )
            };

            if(updateOrderRowCostRate)
            {
            updateOrderRowCostRate(updatedOrder);
            }
        }
    }

    const onChangeOrderFeeValue = (value) =>{
        setOrderFee(Number(value.toString().replace(",", "")));
        if(updateOrderFees){
        updateOrderFees(objOrder, Number(value.toString().replace(",", "")), deliveryFee);
        }
    }

    const onChangeDeliveryFeeValue = (value) =>{
        setDeliveryFee(Number(value.toString().replace(",", "")));
        if(updateOrderFees){
        updateOrderFees(objOrder, orderFee, Number(value.toString().replace(",", "")));
        }
    }

    const getDenominations = (denominations, scale, denominationType, rowID, allowDenominationFees) =>{

    const listDenominations = [];
    if(denominations)
    {
        const denAux = denominations.filter(d => d.NoNotes > 0);
        denAux.forEach((d, index)=>{

            listDenominations.push(
            <div class="uk-width-1-12">
                <div id={`ordersummary54-${rowID}-${index}`} key ={`ordersummary54-${rowID}-${index}`} className="uk-grid" >
                    <div class="uk-width-2-3" style={{paddingLeft:'5px', paddingRight:'5px', textAlign:'center'}}>
                {`${(denominationType === DenominationTypes.amount)? formatToCurrencyWithScale(d.NoNotes,scale): d.NoNotes} x ${d.DenominationDescription}`}    
                    </div>
                    {allowDenominationFees && <div class="uk-width-2-3" style={{paddingLeft:'10px'}}>
                            <NumberInput id={`ordersummary54-fee-${rowID}-${index}`} className="uk-denomination-fee-input" value={d.DenominationFee} type={'Currency'}
                                        onChange ={(event) => {onChangeDenominationFeeValue(event.target.value, d.DenominationDescription, rowID);}} scale={buyScale} disabled={saved} />
                    </div>}
                </div>
            </div>
        )
            
    })}

    return listDenominations;
 }

    const onClickInverseRate = (index, inverse) =>{
        if(inverse)
        {
        const orderRow = objOrder.OrderRows[index];
            
        const orderRowAux = JSON.parse(JSON.stringify(orderRow))

        const inverseRate = orderRowAux.ShowInverseRate;

        orderRowAux.ShowInverseRate = !inverseRate;

        const updatedOrder = {
        ...objOrder,
        OrderRows: objOrder.OrderRows.map((row, i) =>
            i === index ? orderRowAux : row
        )
        };

        if(updateOrderRowCostRate)
        {
        updateOrderRowCostRate(updatedOrder);
        }
        }
    }

    const getRowFee = (denominations, allowDenominationFees) =>{

        let totalRowFee = 0;
        if(denominations && allowDenominationFees)
        {
            const denAux = denominations.filter(d => d.NoNotes > 0);
            denAux.forEach((d)=>
                totalRowFee += Number(d.DenominationFee??0)
            )
                
        }

        return totalRowFee;
    }

    const getRows=()=>{
        const rows = [];

        const canEdit = objOrder.CanEdit??true;
        const cantInverse = saved || !canEdit;
        console.log(cantInverse);
        if(objOrder.OrderRows)
        {
            objOrder.OrderRows.forEach((o, index) =>{
                const denominations = o.MixedDenominations ? <span id={`ordersummary4-span-${index}`} key ={`ordersummary4-span-${index}`} style={{paddingLeft:'10px'}} >Mixed Notes</span>:getDenominations(o.Denominations, o.CurrencyScale, o.DenominationType, index, o.AllowDenominationFees)
                const denFee = getRowFee(o.Denominations, o.AllowDenominationFees);
                const cond = o.NoteConditions ?? 'Regular';
                rows.push(<div id={`ordersummary4-${index}`} key ={`ordersummary4-${index}`} className="uk-grid margin-left-detail-summary-items">

                <div id={`ordersummary41-${index}`} key ={`ordersummary41-${index}`} className="summary-row order-row-text" style={{ width: '220px' }}>{o.CurrencyName}</div>
                <div id={`ordersummary47-${index}`} key ={`ordersummary47-${index}`} className="summary-row order-row-text" style={{ width: '130px' }}>{cond}</div>
                <div id={`ordersummary42-${index}`} key ={`ordersummary42-${index}`} className="uk-width-1-8 summary-row order-row-number">{formatToCurrencyWithScale(o.Amount,o.CurrencyScale)}</div>
                 {showCostRate && 
                <div id={`ordersummary435-${index}`} key ={`ordersummary435-${index}`} className={`${classNameRateRows} summary-row order-row-number`} style={{padding:'px',textAlign:'center'}}>                   
                   {editCostRate && <NumberInput id={`ordersummary54-cost-rate-${index}`} className="uk-order-row-rate-input" value={o.ShowInverseRate? 1/o.CostRate: o.CostRate} type={'Rate'}
                           onChange ={(event) => {onChangeCostRateValue(event.target.value, index)}} scale={o.RatePrecision} disabled={saved} />
                    }
                    { !editCostRate && formatToCurrencyWithScale(o.ShowInverseRate? 1/o.CostRate: o.CostRate,o.RatePrecision)}
                </div>}
                <div id={`ordersummary43-${index}`} key ={`ordersummary43-${index}`} className={`${classNameRateRows} summary-row order-row-number`} style={{padding:'px',textAlign:'center'}}>
                   {editCustomerRate && <NumberInput id={`ordersummary54-rate-${index}`} className="uk-order-row-rate-input" value={o.ShowInverseRate? 1/o.Rate: o.Rate} type={'Rate'}
                           onChange ={(event) => {onChangeRateValue(event.target.value, index)}} scale={o.RatePrecision} disabled={saved} />
                    }
                    {!editCustomerRate && formatToCurrencyWithScale(o.ShowInverseRate? 1/o.Rate: o.Rate,o.RatePrecision)}
                </div>
               
               <div id={`ordersummary447-${index}`} key ={`ordersummary447-${index}`} className={`uk-width-1-12 summary-row order-row-number`}>
                   {formatToCurrencyWithScale(denFee,buyScale)}
                </div>
                
                <div id={`ordersummary44-${index}`} key ={`ordersummary44-${index}`} className={`${classNameRateRows} summary-row order-row-number`}>{formatToCurrencyWithScale(o.BuyAmount + denFee,buyScale)}</div>
                
        
                {showCostRate && 
                <div id={`ordersummary445-${index}`} key ={`ordersummary445-${index}`} className={`uk-width-1-12 summary-row order-row-number`}>
                   {formatToCurrencyWithScale(o.Profit,buyScale)
                    }
                </div>}
                <div id={`ordersummary46-${index}`} key ={`ordersummary46-${index}`} style={{paddingLeft:'10px', width:'60px'}}>
                    <AutorenewRounded id={`inverse-row-${index}`} key ={`inverse-row-${index}`} style={{ marginTop: '10px', marginLeft:'10px', cursor:cantInverse?'default':'pointer' }} disabled={cantInverse} onClick={() => onClickInverseRate(index,!cantInverse)} className={`inverse-rate-icon${!o.ShowInverseRate?'':'-selected'}`}/>
                </div>
            </div>)
            rows.push(<div id={`ordersummary5-${index}`} key ={`ordersummary5-${index}`}  className="uk-grid margin-left-detail-summary" style={{marginTop:'10px'}}>
                <div id={`ordersummary54-${index}`} key ={`ordersummary54-${index}`} className="uk-width-1-12"></div>
                <div id={`ordersummary51-${index}`}  key={`ordersummary51-${index}`} className="" >                    
                <div id={`ordersummary52-${index}`} key ={`ordersummary52-${index}`} className="uk-width-1-1 uk-form-label">{'Denominations'}</div>
                {o.AllowDenominationFees && <div id={`ordersummary52-${index}`} key ={`ordersummary52-${index}`} className="uk-width-1-1 uk-form-label" style={{textAlign:'right'}}>{'Fee'}</div>}
                {allowDenominationType &&<div id={`ordersummary53-${index}`} key ={`ordersummary52-${index}`}className="uk-width-1-8">
                    <Switch key ={`ordersummary53-${index}`} checkedChildren={'Notes'} unCheckedChildren={'Amount'} checked={o.DenominationType === DenominationTypes.notes} disabled={true} />
                </div>}
                </div>
                {denominations}
            </div>)

            })
        }
        return rows;
    }

    const saveOrder = async() =>{
        if(objOrder.TotalProfit < 0)
        {
            if(!saveOrderWithLoss)
            {
                setAlertMessage("You can´t save an Order with negative profit, contact your Admin.");
                setAlertTitle("Error");
                setShowAlert(true);
                return;
            }
        }

        setLoading(true);
        stopTimer();

        const responseSave = await save(objOrder,comments, customerID, userID, lockedSideLower, contactID);
        setLoading(false);    
        const message = [];
        message.push(responseSave.Message);    
        if(responseSave.Success)
        {
            objOrder.Status = "";

            if(responseSave.deliveryFeesMessage && responseSave.deliveryFeesMessage !== '')
            {
                message.push(<br/>);
                message.push(responseSave.deliveryFeesMessage);
                objOrder.DeliveryFee = responseSave.newDeliveryFees;
                //objOrder.DenominationFee = responseSave.newDenominationFees;
                objOrder.OrderFee = responseSave.newOrderFees;  
            }

            if(orderNo === 0)
            {
                getOrderUpdated(responseSave.OrderNo);
            }
            
            //setOrderNo(objOrder.BNOrderNo > 0? objOrder.BNOrderNo:responseSave.OrderNo);
            setSaved(true);
            setIsRunning(false);
        }
        else
        {
            startTimer();
        }

        setAlertTitle(responseSave.Title);
        setAlertMessage(message);
        setShowAlert(true);
    }

    const downloadConfirmation = async() =>{
        setLoading(true);
        const responseConfirmation = await getConfirmation(orderNo);
        setLoading(false);

        if(responseConfirmation?.Success)
        {
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(responseConfirmation.File);
            link.download = responseConfirmation.FileName;
            link.click();
        }
        else
        {
            setAlertTitle(responseConfirmation.Title);
            setAlertMessage(responseConfirmation.Message);
            setShowAlert(true);
        }
    }

      const closeAlert = () => {
        setShowAlert(false);
        setAlertTitle('');
        setAlertMessage('');
    };

    const onCommentsChange = (e) =>{
        setComments(e.target.value);        
    }

    const getStatus = () =>{
        const status = [];
        if(objOrder.StatusProgress)
        {        
            const statusProgress = JSON.parse(objOrder.StatusProgress)
            if(statusProgress && statusProgress.length > 0)
            {
                statusProgress.forEach(s =>
                    {
                        let icon = <CheckOutlined style={{color:s.color}}/> 
                        switch(s.icon)
                        {
                            case 'RocketTwoTone': icon = <RocketTwoTone twoToneColor={s.color}/>; break;
                            case 'TruckOutlined': icon = <FontAwesomeIcon icon={faTruck}  style={{color:s.color, fontSize:'16px'}}/>; break;
                            case 'BankOutlined': icon = <BankOutlined style={{color:s.color}}/>; break;
                            case 'CheckCircleOutlined': icon = <CheckCircleOutlined style={{color:s.color}}/>; break;
                            case 'CarryOutFilled': icon = <CarryOutFilled style={{color:s.color}}/>; break;
                            default: icon = <CheckOutlined style={{color:s.color}}/> 
                        }
                        status.push(<Step title={s.title} description={s.description} status={s.status} icon={icon}/> );                        
                    }
                )
            }
        }
        return status;
    }

    const getSettlementStatus = () =>{
        if(objOrder.SettlementStatusProgress)
        {        
            const statusProgress = JSON.parse(objOrder.SettlementStatusProgress)

            const description = statusProgress.PendingAmount === 0 &&  statusProgress.DateSettlement !== '' ?  statusProgress.DateSettlement : `${formatToCurrencyWithScale(statusProgress.PendingAmount,buyScale)} ${objOrder.BuyCurrency}`;

            return <center style={{display:'grid'}}>
                    <DollarOutlined style={{color:statusProgress.Color ,fontSize:'32px'}}/>
                    <span>{statusProgress.SettlementStatus}</span>
                    <span>{description}</span>
            </center>
        }
    }

    const sendConfirmationEmail = () =>{
        setShowConfirmation(true);
    }

    const yesConfirmation = async() =>{
        setShowConfirmation(false);
        setLoading(true);
        const responseSave = await sendConfirmation(objOrder.BNOrderNo);
        setAlertTitle(responseSave.Title);
        setAlertMessage(responseSave.Message);
        setLoading(false);
        setShowAlert(true);
    }

     const closeConfirmation =() =>{
        setShowConfirmation(false);
    }

    const bookOrder = async() => {
        setShowBookConfirmation(true);
    }

    const yesBookConfirmation = async() => {
        setShowBookConfirmation(false);
        saveOrder();
    }
    
     const closeBookConfirmation =() =>{
        setShowBookConfirmation(false);
    }

    //init timer
    const stopTimer = useCallback(() => {

        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }

        if (isMountedRef.current) {
            setIsRunning(false);
        }

    }, []);

    const onFinishTimer = useCallback(() => {

        stopTimer();

        if (isMountedRef.current) {
            const anyRefresh = (objOrder.OrderRows && objOrder.OrderRows.length > 0) ? objOrder.OrderRows.some(o =>
                o.AutorefreshRate || o.AutorefreshRate === undefined
            ) : true;
            if(anyRefresh)
            {
                setShowAlertTimer(true);
            }
        }

    }, [stopTimer]);

    const startTimer = useCallback(() => {

        stopTimer();

        setSeconds(INITIAL_TIME);
        setIsRunning(true);

        intervalRef.current = setInterval(() => {

            setSeconds(prev => {

                if (prev <= 1) {

                    clearInterval(intervalRef.current);
                    intervalRef.current = null;

                    setTimeout(() => {
                        onFinishTimer();
                    }, 0);

                    return 0;
                }

                return prev - 1;
            });

        }, 1000);

    }, [INITIAL_TIME, onFinishTimer, stopTimer]);

    useEffect(() => {
        if (objOrder?.CanEdit !== 0 && (objOrder?.BNOrderNo === null || objOrder?.BNOrderNo === undefined || objOrder?.BNOrderNo === 0 ) && customerType !== 'Supplier') {
            startTimer();
        } else {
            stopTimer();
            //debugger
            setSaved(!(objOrder?.CanEdit !== 0));
        }

    }, [objOrder?.CanEdit, startTimer, stopTimer]);

    useEffect(() => {
        const anyRefresh = (objOrder.OrderRows && objOrder.OrderRows.length > 0) ? objOrder.OrderRows.some(o =>
            o.AutorefreshRate || o.AutorefreshRate === undefined
        ) : true;
        
        if (!anyRefresh) {
            stopTimer();
            setSeconds(INITIAL_TIME);
        }

    }, [reload]);

    
      const formattedTimeOut = useMemo(() => {
        const minutesTime = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
    
        return `${String(minutesTime).padStart(2, "0")}:${String(
          remainingSeconds
        ).padStart(2, "0")}`;
      }, [seconds]);
    
      const progressTimeout = (seconds / INITIAL_TIME) * 100;

    const closeAlertTimer = () =>{
        setShowAlertTimer(false);

        stopTimer();

        backScreen({
            ...objOrder,
            OrderRows: [...objOrder.OrderRows]
        }, true);
    }
    //end timer

    const onBack = ()=>{
        backScreen({
                    ...objOrder,
                    OrderRows: [...objOrder.OrderRows]
                }, (objOrder?.BNOrderNo === null || objOrder?.BNOrderNo === undefined || objOrder?.BNOrderNo === 0 ))
        }

    return <div id={'ordersummary1'} key ={'ordersummary1'}>
        {orderNo > 0 && <div id={'ordersummary11'} key ={'ordersummary11'} className="uk-grid margin-left-detail-summary">
           <div id={'ordersummary11'} key ={'ordersummary11'} className="uk-width-2-12 summary-ordertitle" style={{paddingLeft:'0px'}}>
            {`Order No: ${orderNo}`}
            </div>
            <div className="uk-width-8-12" style={{paddingLeft:'0px',alignContent: 'center'}}>
                {orderNo > 0 && 
                    <Steps className="step-order">
                        {getStatus()}
                    </Steps>
                }
            </div>
            <div className="uk-width-2-12" style={{paddingLeft:'0px'}}>
                 {getSettlementStatus()}
            </div>
          
        </div>}
            <div id={'ordersummary2'} key ={'ordersummary2'} className='uk-grid margin-left-detail-summary'>
               
                    <div id={'ordersummary211'} key ={'ordersummary211'} className="uk-width-1-1 summary-subtitle">{`Customer`}</div>

                    <div id={'ordersummary2111'} key ={'ordersummary2111'} className="uk-width-1-6">{`Account Number: `}</div>
                    <div id={'ordersummary2112'} key ={'ordersummary2112'} className="uk-width-5-6" >{customerID}</div>
                    <div id={'ordersummary2113'} key ={'ordersummary2113'} className="uk-width-1-6">{`Name: `}</div>
                    <div id={'ordersummary2114'} key ={'ordersummary2114'} className="uk-width-5-6" >{customerName}</div>
                    <div id={'ordersummary2115'} key ={'ordersummary2115'} className="uk-width-1-6">{`Address: `}</div>
                    <div id={'ordersummary2116'} key ={'ordersummary2116'} className="uk-width-5-6" >{customerAddress}</div>
                    <div id={'ordersummary2117'} key ={'ordersummary2117'} className="uk-width-1-6">{`Contact: `}</div>
                    <div id={'ordersummary2118'} key ={'ordersummary2118'} className="uk-width-5-6" >{contactName}</div>
     
            </div>
            
            <div  id={'ordersummary3'} key ={'ordersummary3'} className="uk-grid margin-left-detail-summary">

                <div id={'ordersummary31'} key ={'ordersummary31'} className="uk-width-1-1 summary-subtitle">{lockedSideLower==='sell'?'We Sell':'We Buy'}</div>


                <div id={'ordersummary310'} key ={'ordersummary310'} className="bold-text order-row-title" style={{ width: '220px' }}>{'Currency'}</div>
                <div id={'ordersummary311'} key ={'ordersummary311'} className="bold-text order-row-title" style={{ width: '130px' }}>{'Condition'}</div>
                <div id={'ordersummary312'} key ={'ordersummary312'} className="uk-width-1-8 bold-text order-row-title-number">{'Amount'}</div>
                {showCostRate && <div id={'ordersummary315'} key ={'ordersummary315'} className={`${classNameRateRows} bold-text order-row-title-number`}>{'Market Rate'}</div>}
                <div id={'ordersummary313'} key ={'ordersummary313'} className={`${classNameRateRows} bold-text order-row-title-number`}>{'Rate'}</div>
                
                <div id={'ordersummary318'} key ={'ordersummary318'} className={`uk-width-1-12 bold-text order-row-title-number`}>{'Fee'}</div>
                <div id={'ordersummary314'} key ={'ordersummary314'} className={`${classNameRateRows} bold-text order-row-title-number`}>{`${objOrder.BuyCurrency} Value`}</div>
                
                {showCostRate && <div id={'ordersummary316'} key ={'ordersummary316'} className={`uk-width-1-12 bold-text order-row-title-number`}>{'Profit'}</div>}
                <div id={'ordersummary317'} key ={'ordersummary317'} style={{paddingLeft:'10px', width:'60px'}}>
                    {!saved && (objOrder?.BNOrderNo === null || objOrder?.BNOrderNo === undefined || objOrder?.BNOrderNo === 0 ) && customerType !== 'Supplier' &&
                         <Progress type="circle" percent={progressTimeout} className="ant-progress-inner-order" format={() => `${formattedTimeOut}`} /> }
                </div>
            </div>
            {getRows()}         
            <div id={'ordersummary6'} key={'ordersummary6'} className="uk-grid margin-left-detail-summary">
                <div id={'ordersummary65'} key ={'ordersummary65'} className="uk-width-1-1 summary-subtitle">{`Subtotal `}</div>
            </div>
            <div id={'ordersummary7'} key={'ordersummary7'} className="uk-grid margin-left-detail-summary" style={{marginTop:'0px'}}>
                <div id={'ordersummary71'} key={'ordersummary71'} className="uk-width-1-8">{`Subtotal ${objOrder.BuyCurrency}`}</div>
                <div id={'ordersummary72'} key={'ordersummary72'} className="uk-width-1-12" style={{textAlign:'right'}}>{baseCurrencySymbol}</div>
                <div id={'ordersummary73'} key={'ordersummary73'} className="uk-width-1-8 uk-amount" style={{paddingLeft:'0px'}}>{formatToCurrencyWithScale(totalOrder + denominationFee,buyScale)}</div>
                <div id={'ordersummary74'} key={'ordersummary74'} className="uk-width-1-8" >{objOrder.BuyCurrency !== baseCurrency && objOrder.CrossRate ?`${objOrder.BuyCurrency}/${baseCurrency}: ${objOrder.CrossRate}`:''}</div>
            </div>

            {/*<div id={'ordersummaryfeeden7'} key={'ordersummaryfeeden7'} className="uk-grid margin-left-detail-summary" style={{marginTop:'5px'}}>
                <div id={'ordersummaryfeeden71'} key={'ordersummaryfeeden71'} className="uk-width-1-12"></div>
                <div id={'ordersummaryfeeden72'} key={'ordersummaryfeeden72'} className="uk-width-1-12" style={{paddingLeft:'5px'}}><label className="uk-form-label" htmlFor={`ordersummary84-fee`}>Denomination Fee</label></div>
                <div id={'ordersummaryfeeden73'} key={'ordersummaryfeeden73'} className="uk-width-1-12 uk-amount"><NumberInput id={`ordersummary84-fee`} className="uk-denomination-fee-input" value={denominationFee} scale={buyScale} disabled={true} type={'Currency'} /></div>
            </div>*/}
            <div id={'ordersummaryfeeorder7'} key={'ordersummaryfeeorder7'} className="uk-grid margin-left-detail-summary" style={{marginTop:'5px'}}>
                <div id={'ordersummaryfeeorder71'} key={'ordersummaryfeeorder71'} className="uk-width-1-12"></div>
                <div id={'ordersummaryfeeorder72'} key={'ordersummaryfeeorder72'} className="uk-width-1-12" style={{paddingLeft:'5px'}}><label className="uk-form-label" htmlFor={`ordersummary85-fee`}>Order Fee</label></div>
                <div id={'ordersummaryfeeorder73'} key={'ordersummaryfeeorder73'} className="uk-width-1-12 uk-amount"><NumberInput id={`ordersummary85-fee`} className="uk-denomination-fee-input" value={orderFee} disabled={saved}  type={'Currency'}
                                      onChange ={(event) => {onChangeOrderFeeValue(event.target.value);}} scale={buyScale} /></div>
            </div>
            <div id={'ordersummaryfeedel7'} key={'ordersummaryfeedel7'} className="uk-grid margin-left-detail-summary" style={{marginTop:'5px'}}>
                <div id={'ordersummaryfeedel71'} key={'ordersummaryfeedel71'} className="uk-width-1-12"></div>
                <div id={'ordersummaryfeedel72'} key={'ordersummaryfeedel72'} className="uk-width-1-12" style={{paddingLeft:'5px'}}><label className="uk-form-label" htmlFor={`ordersummary86-fee`}>Delivery Fee</label></div>
                <div id={'ordersummaryfeedel73'} key={'ordersummaryfeedel73'} className="uk-width-1-12 uk-amount"><NumberInput id={`ordersummary86-fee`} className="uk-denomination-fee-input" value={deliveryFee} disabled={saved}  type={'Currency'}
                                      onChange ={(event) => {onChangeDeliveryFeeValue(event.target.value);}} scale={buyScale} /></div>
            </div>

            <div id={'ordersummary8'} key={'ordersummary8'}  className="uk-grid margin-left-detail-summary" style={{marginTop:'0px'}}>
                <div id={'ordersummary81'} key={'ordersummary81'} className="uk-width-1-8" style={{paddingTop:'15px'}}>{'Total Fees'}</div>
                <div id={'ordersummary82'} key={'ordersummary82'} className="uk-width-1-12" style={{paddingTop:'15px', textAlign:'right'}}>{baseCurrencySymbol}</div>
                <div id={'ordersummary83'} key={'ordersummary83'} className="uk-width-1-8 uk-amount" style={{paddingLeft:'0px', paddingTop:'15px'}}>{formatToCurrencyWithScale((Number(orderFee) + Number(deliveryFee)),buyScale)}</div>
                <div id={'ordersummary84'} key={'ordersummary84'} className="uk-width-1-8" style={{paddingTop:'15px', paddingLeft:'5px'}}>{'Settlement Instrument'}</div>
                <div id={'ordersummary85'} key={'ordersummary85'} className="uk-width-1-4" style={{paddingTop:'15px'}}>{objOrder.SettlementInstrument}</div>
            </div>

            <div id={'ordersummary9'} key={'ordersummary9'}  className="uk-grid margin-left-detail-summary" style={{marginTop:'0px'}}>
                <div id={'ordersummary91'} key={'ordersummary91'} className="uk-width-1-8">{lockedSideLower==='sell'?'Total Due From Client':'Total Due To Client'}</div>
                <div id={'ordersummary92'} key={'ordersummary92'} className="uk-width-1-12" style={{textAlign:'right'}}>{baseCurrencySymbol}</div>
                
                {lockedSideLower === 'buy' && <div id={'ordersummary93'} key={'ordersummary93'} className="uk-width-1-8 uk-amount" style={{paddingLeft:'0px'}}>{formatToCurrencyWithScale(((totalOrder + Number(denominationFee) ) - (Number(orderFee) + Number(deliveryFee))),buyScale)}</div>}
                {lockedSideLower !== 'buy' && <div id={'ordersummary93'} key={'ordersummary93'} className="uk-width-1-8 uk-amount" style={{paddingLeft:'0px'}}>{formatToCurrencyWithScale((totalOrder + Number(orderFee) + Number(denominationFee) + Number(deliveryFee)),buyScale)}</div>}
                
                <div id={'ordersummary94'} key={'ordersummary94'} className="uk-width-1-8" style={{paddingLeft:'5px'}}>{'Settlement Method'}</div>
                <div id={'ordersummary95'} key={'ordersummary95'} className="uk-width-1-4" >{objOrder.SettlementMethod}</div>
            </div>

            <div id={'ordersummary20'} key={'ordersummary20'} className="uk-grid margin-left-detail-summary">
                <div id={'ordersummary201'} key ={'ordersummary201'} className="uk-width-1-1 summary-subtitle">{'Comments'}</div>
            </div>

            {!saved  && 
            <div id={'ordersummary202'} key ={'ordersummary202'} className="uk-grid margin-left-detail-summary">
                <textarea id={'ordersummaryComments'} key={'ordersummaryComments'} className='uk-textarea' value={comments} onChange={onCommentsChange} /> 
            </div>
            }
            {saved && 
            <div id={'ordersummary203'} key ={'ordersummary203'} className="uk-grid margin-left-detail-summary">
                <div id={'ordersummary204'} key ={'ordersummary204'} className="uk-width-1-1">{`${comments}`}</div>
            </div>
            }

            <div id={'ordersummary10'} key={'ordersummary10'} className="uk-grid margin-left-detail-summary">
                <div id={'ordersummary101'} key ={'ordersummary101'} className="uk-width-1-1 summary-subtitle">{`${ lockedSideLower==='sell' || showCompanyAddress ?'Delivery to':'Pick Up from '} `}</div>
            </div>

            <div id={'ordersummary11'} key={'ordersummary11'} className="uk-grid margin-left-detail-summary" style={{marginTop:'0px'}}>
                <div id={'ordersummary111'} key ={'ordersummary111'} className="uk-width-1-6">{`Delivery Method `}</div>
                <div id={'ordersummary112'} key ={'ordersummary112'} className="uk-width-5-6">{`${objOrder.DeliveryMethod}`}</div>
            </div>
            {/*showCompanyAddress && 
            <div id={'ordersummary141'} key={'ordersummary141'} className="uk-grid margin-left-detail-summary" style={{marginTop:'0px'}}>
                <div id={'ordersummary1411'} key ={'ordersummary1411'} className="uk-width-1-6">{`Delivery From `}</div>
                <div id={'ordersummary1412'} key ={'ordersummary1412'} className="uk-width-5-6">{`${objOrder.DeliveryText} `}</div>
            </div>*/}
            {showCompanyAddress && 
            <div id={'ordersummary12'} key={'ordersummary12'} className="uk-grid margin-left-detail-summary" style={{marginTop:'0px'}}>
                <div id={'ordersummary121'} key ={'ordersummary121'} className="uk-width-1-6">{`Delivery To `}</div>
                <div id={'ordersummary122'} key ={'ordersummary122'} className="uk-width-5-6">{`${companyAddress}`}</div>
            </div>}

            {showVault && 
            <>
            <div id={'ordersummary141'} key={'ordersummary141'} className="uk-grid margin-left-detail-summary" style={{marginTop:'0px'}}>
                <div id={'ordersummary1411'} key ={'ordersummary1411'} className="uk-width-1-6">{`Pick Up From `}</div>
                <div id={'ordersummary1412'} key ={'ordersummary1412'} className="uk-width-5-6">{`${objOrder.DeliveryText} `}</div>
            </div>
            <div id={'ordersummary131'} key={'ordersummary131'} className="uk-grid margin-left-detail-summary" style={{marginTop:'0px'}}>
                <div id={'ordersummary1311'} key ={'ordersummary131'} className="uk-width-1-6">{'Release Date'}</div>
                <div id={'ordersummary1321'} key ={'ordersummary132'} className="uk-width-5-6">{`${new Date(objOrder.DeliveryDate).toDateString()}`}</div>
            </div></>
            }

            {isDropOff &&
            <div id={'ordersummary13'} key={'ordersummary13'} className="uk-grid margin-left-detail-summary" style={{marginTop:'0px'}}>
                <div id={'ordersummary131'} key ={'ordersummary131'} className="uk-width-1-6">{'Release Date'}</div>
                <div id={'ordersummary132'} key ={'ordersummary132'} className="uk-width-5-6">{`${new Date(objOrder.DeliveryDate).toDateString()}`}</div>
            </div>

            }

            {!showCompanyAddress && !showCompanyAddressWithoutLocation && !showVault && !isDropOff &&
            <>
            <div id={'ordersummary13'} key={'ordersummary13'} className="uk-grid margin-left-detail-summary" style={{marginTop:'0px'}}>
                <div id={'ordersummary131'} key ={'ordersummary131'} className="uk-width-1-6">{'Release Date'}</div>
                <div id={'ordersummary132'} key ={'ordersummary132'} className="uk-width-5-6">{`${new Date(objOrder.DeliveryDate).toDateString()}`}</div>
            </div>
            <div id={'ordersummary14'} key={'ordersummary14'} className="uk-grid margin-left-detail-summary" style={{marginTop:'0px'}}>
                <div id={'ordersummary141'} key ={'ordersummary141'} className="uk-width-1-6">{isPartnerPickUp?`Pick up from `:`Address `}</div>
                <div id={'ordersummary142'} key ={'ordersummary142'} className="uk-width-5-6">{`${objOrder.DeliveryText} `}</div>
            </div>
            <div id={'ordersummary15'} key={'ordersummary15'} className="uk-grid margin-left-detail-summary" style={{marginTop:'0px'}}>
                <div id={'ordersummary151'} key ={'ordersummary151'} className="uk-width-1-6">{`Contact `}</div>
                <div id={'ordersummary152'} key ={'ordersummary152'} className="uk-width-5-6">{`${objOrder.DeliveryContactName}`}</div>
            </div></>}

            {/*showCompanyAddressWithoutLocation &&
            <>
            <div id={'ordersummary12'} key={'ordersummary12'} className="uk-grid margin-left-detail-summary" style={{marginTop:'0px'}}>
                <div id={'ordersummary121'} key ={'ordersummary121'} className="uk-width-1-6">{`Pick Up From `}</div>
                <div id={'ordersummary122'} key ={'ordersummary122'} className="uk-width-5-6">{`${companyAddress}`}</div>
            </div>
            <div id={'ordersummary13'} key={'ordersummary13'} className="uk-grid margin-left-detail-summary" style={{marginTop:'0px'}}>
                <div id={'ordersummary131'} key ={'ordersummary131'} className="uk-width-1-6">{'Release Date'}</div>
                <div id={'ordersummary132'} key ={'ordersummary132'} className="uk-width-5-6">{`${new Date(objOrder.DeliveryDate).toDateString()}`}</div>
            </div></>*/}
            {showCompanyAddressWithoutLocation &&
            <>
            <div id={'ordersummary13'} key={'ordersummary13'} className="uk-grid margin-left-detail-summary" style={{marginTop:'0px'}}>
                <div id={'ordersummary131'} key ={'ordersummary131'} className="uk-width-1-6">{'Release Date'}{`${objOrder.DeliveryMethod}` === 'Pick up at the vault'? ' (after 3pm)': ''}</div>
                <div id={'ordersummary132'} key ={'ordersummary132'} className="uk-width-5-6">{`${new Date(objOrder.DeliveryDate).toDateString()}`}</div>
            </div></>}

            <Divider/>
            <div className="margin-left-detail-summary" style={{ marginTop: '20px', marginBottom: '20px', padding: 0, textAlign:'end' }}>
                {saved && !fromSearch && !view &&
                <button className="uk-button uk-button-green" onClick={() => newOrder(customerID, contactID, customerName)}>
                    {'New Order'}
                </button>}
                {saved && objOrder.Status !== 'Voided' && 
                <button className="uk-button uk-button-green" onClick={sendConfirmationEmail}>
                    {'Send Confirmation'}
                </button>}
                {saved &&
                <button className="uk-button uk-button-green" onClick={downloadConfirmation}>
                    {'Download Confirmation'}
                </button>}
                {!saved && !view &&
                <button className="uk-button uk-button-green" onClick={onBack}>
                    {'Back'}
                </button>
                }
                {!saved && !view &&
                <button className="uk-button uk-button-green" onClick={saveOrder/*bookOrder*/} >
                    {'Book'}
                </button>
                }
                <button className="uk-button uk-button-green" onClick={cancelOrder}>
                    {'Exit'}
                </button>
            </div>
            <LoadingBox loading={loading}/>
            <AlertBox open={showAlert} onClose={closeAlert} title={alertTitle} message={alertMessage} type="Ok" okClick={closeAlert} />
            <AlertBox open={showConfirmation} title={'Send Confirmation'}
                            message="Are you sure you want to send this order confirmation?"
                            type="Yes/No"
                            onClose={closeConfirmation}
                            yesClick={yesConfirmation}
                            noClick={closeConfirmation}/>
            <AlertBox open={showAlertTimer} onClose={closeAlertTimer} title={'Error'} message={'The rates have expired, you will return to the previous page to refresh them.'} type="Ok" okClick={closeAlertTimer} />
            <AlertBox open={showBookConfirmation} title={'Book Confirmation'}
                            message="Are you sure you want to book this order?"
                            type="Yes/No"
                            onClose={closeBookConfirmation}
                            yesClick={yesBookConfirmation}
                            noClick={closeBookConfirmation}/>
        </div>
}

export default OrderSummary